export default __webpack_public_path__ + "static/media/general2024RealCase1.bf70f065.jpg";